<!--新增、修改下拉项弹窗-->
<template>
	<el-dialog append-to-body :close-on-press-escape="false" :modal-append-to-body="false" :close-on-click-modal="false" :title="title" :visible.sync="dialogFormVisible" width="600px">
		<el-form v-if="dialogFormVisible" :model="formSave" ref="formSaveRef" label-width="100px" label-position="right" :rules="rules" :disabled="onlyread">

			<div class="grid-content bg-purple-light">
				<el-form-item label="代码 : " prop="optionCode">
					<el-input v-model="formSave.optionCode" autocomplete="off" placeholder="代码" style="width: 100%"></el-input>
				</el-form-item>
			</div>

			<div class="grid-content bg-purple-light">
				<el-form-item label="名称 : " prop="optionName">
					<el-input v-model="formSave.optionName" autocomplete="off" placeholder="名称" style="width: 100%"></el-input>
				</el-form-item>
			</div>

			<div class="grid-content bg-purple-light">
				<el-form-item label="序号 : " prop="sequenceNumber">
					<el-input v-model="formSave.sequenceNumber" placeholder="序号" style="width: 100%"></el-input>
				</el-form-item>
			</div>

			<div class="grid-content bg-purple">
				<el-form-item required label="状态 : ">
					<el-radio-group v-model="formSave.optionState">
						<el-radio name='type' label="1">启用</el-radio>
						<el-radio name='type' label="0">禁用</el-radio>
					</el-radio-group>
				</el-form-item>
			</div>

		</el-form>
		<div slot="footer" class="dialog-footer" v-if="!onlyread">
			<el-button @click="getCancelBtn()">取 消</el-button>
			<el-button type="primary" @click="commit" :loading="loading">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
	name: "manageOption",
	components: {},
	props: ["itemId"],
	data() {
		return {
			optionId: "",
			loading: false,
			dialogFormVisible: false,
			onlyread: false,
			formSave: {
				optionCode: "",
				optionName: "",
				sequenceNumber: "",
				optionState: ""
			},
			title: "新增可选项",

			operType: "",
			rules: {
				optionCode: [{ required: true, message: '请输入字段代码', trigger: 'blur' }],
				optionName: [{ required: true, message: '请输入字段名称', trigger: 'blur' }],
				optionState: [{ required: true, message: '请选择状态', trigger: 'blur' }],
				sequenceNumber: [{ required: true, message: '请输入序号', trigger: 'blur' }],
			}
		}
	},
	computed: {
		...mapGetters([
			'userInfo',
		]),
	},
	watch: {
		operType: function() {
			this.setFormState();
		},
	},
	mounted() {
	},
	methods: {
		init() {
			this.resetFormData();
			this.dialogFormVisible = true;
		},

		commit() {
			this.$refs.formSaveRef.validate((valid) => {
				if (valid) {
					this.loading = true;

					let queryData = Object.assign({}, this.formSave);

					let executeFunction;
					if (this.operType == "create") {
						executeFunction = this.$api.reportDefinitionOptionAddJson;
					} else if (this.operType == "update") {
						executeFunction = this.$api.reportDefinitionOptionEditJson;
					}


					executeFunction({
						optionCode: queryData.optionCode,
						optionId: this.optionId,
						optionName: queryData.optionName,
						optionState: queryData.optionState,
						parentId: "",
						seqNum: queryData.sequenceNumber,
						itemId: this.itemId,
					}).then(res => {
						if (!res) return false;
						this.$message.success("操作成功");
						this.$emit("requestList");
						this.dialogFormVisible = false;
					}).finally(() => {
						this.loading = false;
					})
				} else {
					return false;
				}
			});
		},
		// 取消按钮回调
		getCancelBtn() {
			this.resetFormData();
			this.$refs.formSaveRef.resetFields()
			this.dialogFormVisible = false;
			// this.$emit("requestList");
		},


		// 新增下拉项
		addOption() {
			this.operType = "create";
			this.init();
		},
		// 更新下拉项
		updateOption(conditionData) {
			this.operType = "update";
			this.init();
			this.setFormdata(conditionData);
		},
		setFormdata(optionData) {
			console.log(optionData.optionId)
			this.optionId = optionData.optionId;
			this.formSave = {
				optionCode: optionData.optionCode,
				optionName: optionData.optionName,
				sequenceNumber: optionData.seqNum,
				optionState: optionData.optionState
			};
		},

		setFormState() {
			switch (this.operType) {
				case "create":
					this.title = "新增可选项";
					this.onlyread = false;
					break;
				case "update":
					this.title = "修改可选项"
					this.onlyread = false;
					break;
				default:
					return;
			}
		},

		resetFormData() {
			this.formSave = {
				optionCode: "",
				optionName: "",
				sequenceNumber: "",
				optionState: "1"
			};
		},
	}
}
</script>
